module.exports = __webpack_public_path__ + "static/media/mergeContactsLarge.2884a85f.svg";